export default {
  avatar: 'Service photo / Logo',
  callToAction: 'Select a type of service',
  header1: 'Add service to company',
  header2: 'Add photos for service',
  header3: 'Add opening hours for service'
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/addService.js